import React from 'react'
import { isEmpty } from 'lodash'

import { setValue, getPhoneFormatter } from 'helpers/common'
import { TicketLabel } from 'features/Ticket'

import type { ICustomerInfo } from './model'
import type { TicketLabelProps } from 'features/Ticket/TicketLabel'

const renderCustomerInfo = (
  detail: ICustomerInfo,
  isLoading: boolean,
): JSX.Element[] => {
  const {
    companyName = '',
    branchName = '',
    branchPhoneNumber = '',
    email = '',
    address = '',
    reporterName = '',
    reporterPhoneNumber = '',
  } = detail

  const list: TicketLabelProps[] = [
    {
      key: 'companyName',
      title: 'ticket:companyName.title',
      value: companyName,
      skeletonWidthTitle: '65px',
      skeletonWidthValue: '80%',
      isRow: true,
    },
    {
      key: 'branchName',
      title: 'ticket:branchName.title',
      value: setValue(branchName),
      skeletonWidthTitle: '65px',
      skeletonWidthValue: '100%',
      isRow: true,
    },
    {
      key: 'branchPhoneNumber',
      title: 'branch:phone.label',
      value: !isEmpty(branchPhoneNumber)
        ? getPhoneFormatter(branchPhoneNumber)
        : '-',
      skeletonWidthTitle: '48px',
      skeletonWidthValue: '55%',
      isRow: true,
    },
    {
      key: 'email',
      title: 'common:email.label',
      value: setValue(email),
      skeletonWidthTitle: '48px',
      skeletonWidthValue: '100%',
      isRow: true,
    },
    {
      key: 'address',
      title: 'common:address.label',
      value: setValue(address),
      skeletonWidthTitle: '65px',
      skeletonWidthValue: '100%',
      isRow: true,
    },
    {
      key: 'reporterName',
      title: 'ticket:reporterName.title',
      value: setValue(reporterName),
      skeletonWidthTitle: '65px',
      skeletonWidthValue: '100%',
      isRow: true,
    },
    {
      key: 'reporterPhoneNumber',
      title: 'ticket:reporterPhoneNumber.title',
      value: !isEmpty(reporterPhoneNumber)
        ? getPhoneFormatter(reporterPhoneNumber)
        : '-',
      skeletonWidthTitle: '65px',
      skeletonWidthValue: '55%',
      isRow: true,
    },
  ]

  return list.map((item, index) => (
    <TicketLabel
      key={`ticket-info-${index}`}
      isLoading={isLoading}
      title={item.title}
      value={item.value}
      skeletonWidthTitle={item.skeletonWidthTitle}
      skeletonWidthValue={item.skeletonWidthValue}
      isShowSkeletonTitle
      isRow={item.isRow}
      minWidthTitle={125}
    />
  ))
}

export default renderCustomerInfo
